import { useCallback, useEffect } from 'react'

export const getLocationHash = () => location.hash.slice(1)

export default function useHashChange(callback: () => void) {
  const evtType = 'hashchange'

  const handleHash = useCallback(() => {
    callback()
  }, [callback])

  useEffect(() => {
    window.addEventListener(evtType, handleHash)
    return () => {
      window.removeEventListener(evtType, handleHash)
    }
  }, [handleHash])
}
